import React from 'react';

export const cashReplenishmentSortasiConfig = [
  {
    path: '/sortation',
    component: React.lazy(() => import('./listing/listing')),
  },
  {
    path: '/sortation/overview',
    component: React.lazy(() => import('./overview/overview')),
  },
  {
    path: '/sortation/confirmationOfSortingResults',
    component: React.lazy(() =>
      import('./confirmationOfSortingResults/confirmationOfSortingResults'),
    ),
  },
  {
    path: '/sortation/difference-confirmation',
    component: React.lazy(() =>
      import('./differenceConfirmation/differenceConfirmation'),
    ),
  },
  {
    path: '/sortation/view',
    component: React.lazy(() => import('./view/view')),
  },
  {
    path: '/sortation/overviewOfSortingResults',
    component: React.lazy(() =>
      import('./overviewOfSortingResults/overviewOfSortingResults'),
    ),
  },
];
